import React, { useEffect, useState } from 'react';
import { formatTime } from '../../../../services/formatting';
import { useParams } from '../../../../services/routing/useRouteInfo';
import { SelectQuery } from '../../../shared/inputs/selectQuery';
import { Telephone } from '../../../shared/links/telephone';
import { FormMode, FormView } from '../../../shared/view/form';
import { isValidPhoneNumber } from 'react-phone-number-input';

import Input from 'react-phone-number-input/input';


export const BranchForm = () => {

    let { id } = useParams();

    const [len, setLen] = useState(id?.split(',')?.length ?? 0);

    useEffect(() => {
        setLen(id?.split(',')?.length ?? 0);
    }, [id]);

    return <FormView
        ids={id?.split(',').map(i => parseInt(i ?? ''))}
        resourceName={len > 1 ? 'Branches' : 'Branch'}
        processData={d => {

            d._managerDisplayName = undefined;

            if (d.note === null)
                d.note = '';
                
            return d;
        }}
        nameFunction={r => r?.name}
        restEndpoint='locations/branches'
        formMode={len === 0 ? FormMode.Add : FormMode.Edit}
        format={{
            'name': {
                max: 50,
            },
            'walkinStart': {
                type: 'time',
                default: '09:00',
                forChangeLog: v => formatTime(v.walkinStart),
                fromApi: d => d?.walkinStart?.padStart(5, '0'),
            },
            'walkinEnd': {
                type: 'time',
                default: '14:00',
                forChangeLog: v => formatTime(v.walinEnd),
                fromApi: d => d?.walkinEnd?.padStart(5, '0'),
            },
            'phone': {
                type: 'tel',
                forChangeLog: v => <Telephone number={v.phone} />,
                validate:  v => (len > 1 && v.phone === null) || v.phone == null || isValidPhoneNumber(v.phone) ? null : 'Invalid phone number',
            },
            'address': {
                max: 500,
                rows: 2,
                type: 'textarea',
            },
            // Only edit notes individually
            ...(len <= 1 ? {
                'note': {
                    max: 4000,
                    rows: 4,
                    type: 'textarea',
                    required: false,
                },
                'exceptions': {
                    max: 4000,
                    rows: 4,
                    type: 'textarea',
                    required: false,
                },
            } : {}),
            'brightreeId': {
                type: 'number',
                required: true,
            },
            'managerName': {
                max: 50,
                fromApi: v => v?.manager?.displayName,
                didChange: (data, input) => input.managerName !== null && data?.manager?.displayName !== input.managerName,
            },
            'brightreeTaskId': {
                max: 50,
                required: true,
            },
            'googleReview': {
                max: 150,
                rows: 4,
                type: 'textarea',
                required: false,
            },
        }}
        listLocation='locations/branches'
    />
}

const ManagerInput = ({setFieldValue, isSubmitting, data, name, len}) => {
    const [manager, setManager] = useState(len === 1 ?
            data[0]?.manager ?? {}
            : len > 1 ? {id: null, displayName: ''}
            : {}
        );

    useEffect(() => {
        setFieldValue(name, manager?.id ?? null)
        if (!((manager?.id ?? null) === null && manager?.displayName === ''))
            setFieldValue('_managerDisplayName', manager?.displayName)
    }, [manager]);

    return <SelectQuery
        value={manager}
        onChange={setManager}
        placeholder={len > 1 && (manager?.id ?? null) === null ? '—' : undefined}
        pluralResourceName='Users'
        restEndpoint='/users'
        disabled={isSubmitting}
        disabledFunction={r => r.archived}
        nameFunction={r => r.displayName}
        allowEmpty={true}
    />
}